import { createReducer, createActions  } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  data: [],
  loading: false,
})

const { Types, Creators } = createActions({
  setCrossSellItemsLoading: ['val'],
  setCrossSellItems: ['data'],
  getCrossSellItems: ['merchantKey', 'loading'],
})

export const setCrossSellItemsLoadingReducer = state => state.set('loading', true)

export const setCrossSellItemsReducer = (state, { data }) =>
  state.set('data', data).set('loading', false)

export const crossSellItemReducer = createReducer(INITIAL_STATE, {
  [Types.SET_CROSS_SELL_ITEMS]: setCrossSellItemsReducer,
  [Types.SET_CROSS_SELL_ITEMS_LOADING]: setCrossSellItemsLoadingReducer,
})

export const CrossSellItemTypes = Types
export default Creators


// WEBPACK FOOTER //
// ./src/reducers/crossSellItemReducer.js